module.exports = __webpack_public_path__ + "img/logistics-park.00db1e34.png";